module.exports = __webpack_public_path__ + "img/banner-hsia.25aff7eb.webp";